module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-header-container"
  }, [_c('button', {
    staticClass: "arrow",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeMonth(1)
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('p', {
    staticClass: "calendar-title"
  }, [_vm._v(_vm._s(_vm.dateInformation.monthName) + " " + _vm._s(_vm.year))]), _vm._v(" "), _c('button', {
    staticClass: "arrow",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeMonth(2)
      }
    }
  }, [_vm._v(">")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-883d9598","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/calendar/CalendarHeader.vue
// module id = 755
// module chunks = 108